const homeTranslations = {
  'pt-br': 'Página Inicial',
}

module.exports = {
  homeTranslations,
}
